export default __webpack_public_path__ + "static/media/5nance-partner.41efd814.svg";